// extracted by mini-css-extract-plugin
export default {"metricTile":"MetricTile_metricTile__xRUID","iconBadge":"MetricTile_iconBadge__n2f0h","textCol":"MetricTile_textCol__q4G3e"};